<template>
  <div class="containerstylemaps">
    <div class="container_type_map_opcion" v-if="opcionview">
      <div style="text-align: right; flex-direction: row; margin-right: 10px;">
        <a href="#" class="close" id="closebuscar" @click="viewopmap()">
          <img :src="require(`@/assets/icon-close.svg`)" width="5px" height="5px" style="width: 10px">
        </a>
      </div>
      <div class="titulo_heramientas"><span>ESTILOS DE MAPAS</span></div>
      <div style="display: flex; flex-direction: row">
        <div class="item_opcion_mapa">
          <img :src="require(`@/assets/img-map-style-default.png`)" @click="setTypeMap('roadmap')">
          <span style="font-size: 0.6rem;">Default</span>
        </div>
        <div class="item_opcion_mapa">
          <img :src="require(`@/assets/img-map-style-satellite.png`)" @click="setTypeMap('satellite')">
          <span style="font-size: 0.6rem;">Satelite</span>
        </div>
        <div class="item_opcion_mapa">
          <img :src="require(`@/assets/img-map-style-hybrid.png`)" @click="setTypeMap('hybrid')">
          <span style="font-size: 0.6rem;">Relieve</span>
        </div>
      </div>
    </div>
    <div class="typemap" v-if="mapTypeId =='Default'" @click="viewopmap()">
      <div class="container_imagen_type"><img :src="require(`@/assets/img-map-style-default.png`)"></div>
      <div class="labeltypemap">{{ mapTypeId }}</div>
    </div>
    <div class="typemap" v-if="mapTypeId =='Satelite'" @click="viewopmap()">
      <div class="container_imagen_type"><img :src="require(`@/assets/img-map-style-satellite.png`)"></div>
      <div class="labeltypemap">{{ mapTypeId }}</div>
    </div>
    <div class="typemap" v-if="mapTypeId =='Relieve'" @click="viewopmap()">
      <div class="container_imagen_type"><img :src="require(`@/assets/img-map-style-hybrid.png`)"></div>
      <div class="labeltypemap">{{ mapTypeId }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MapStyleControl",
  data() {
    return {
      mapTypeId: 'Relieve',
      opcionview: false,
    };
  },
  props: ['typempas'],
  methods: {
    setTypeMap(typeMap) {
      this.$root.$emit("map-set-type", typeMap);
      if (typeMap == "roadmap") {
        this.mapTypeId = "Default";
      } else if (typeMap == "satellite") {
        this.mapTypeId = "Satelite";
      } else if (typeMap == "hybrid") {
        this.mapTypeId = "Relieve";
      }
    },
    viewopmap() {
      if (this.opcionview == true) {
        this.opcionview = false;
      } else {
        this.opcionview = true;
      }
    }
  },
}
</script>

<style scoped lang="scss">
.titulo_heramientas {
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 0.70rem;
}

.container_tools {
  display: flex;
  flex-direction: column;
}

.containerstylemaps {
  background: #fbfbfc;
  color: black;
  z-index: 20;
  position: absolute;
  bottom: 1.9%;
  top: auto;
  right: 5%;
  font-size: 1rem;
  border-radius: 5px;
}

.containerstylemaps img {
  width: 40px;
  display: inline-block;
}

.typemap {
  font-size: 0.75rem;
  font-weight: 600;
  width: 100%;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  text-align: center;
}

.container_type_map_opcion {
  z-index: 20;
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 2.938rem;
  top: auto;
  right: 0rem;
  background: #FFFFFF;
  width: 250px;
}

.item_opcion_mapa {
  padding: 15px;
  cursor: pointer;
  text-align: center;
  font-weight: 600;
  width: 100px;
  text-align: center;
}

.labeltypemap {
  width: 100%;
  text-align: center;
  margin-top: 5px;
  font-weight: 600;
}
</style>